import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { createCustomElement } from '@angular/elements';
import { PtlXhrModule } from '@ptl/xhr';
import { MaterialGlobalModule } from 'src/app/shared/modules/material-global.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgReduxFormConnectModule, NgReduxFormConnectArrayModule } from '@ptl/angular-redux-form';
import { NgReduxModule } from '@ptl/angular-redux-store';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { ReducersRegistryModule } from 'src/app/shared/modules/reducers-registry.module';
import { LisRatesComponent } from './lis-rates/lis-rates.component';
import { BirthdayTimelineComponent } from './birthday-timeline/birthday-timeline.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { PlanDocsByCountyComponent } from './plan-docs-by-county/plan-docs-by-county.component';
import { LisRatesDisplayPipe } from './lis-rates/lis-rates-display.pipe';
import { StateModuleReadyService } from '@ptl/state';
import { ProductsDocPdfViewComponent } from './products-doc-pdf-view/products-doc-pdf-view.component';

@NgModule({
    declarations: [
        LisRatesComponent,
        LisRatesDisplayPipe,
        BirthdayTimelineComponent,
        PlanDocsByCountyComponent,
        ProductsDocPdfViewComponent
    ],
    imports: [
        CommonModule,
        MaterialGlobalModule,
        FormsModule,
        ReactiveFormsModule,
        NgReduxModule,
        NgReduxFormConnectModule,
        NgReduxFormConnectArrayModule,
        PtlXhrModule,
        SharedComponentsModule,
        ReducersRegistryModule,
        ReactiveFormsModule
    ],
    providers: [ { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } }],
    exports: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})


export class MarketingModule {

    constructor(
        private injector: Injector,
        private stateModuleReadyService: StateModuleReadyService
    ) {
        // console.log("MarketingModule - constructor");
        this.stateModuleReadyService.ready$.subscribe((isReady: boolean) => {
            if (isReady) {
                this.createElementIfDoesNotExist('sxe-lis-rates', LisRatesComponent);
                this.createElementIfDoesNotExist('sxe-birthday-timeline', BirthdayTimelineComponent);
                this.createElementIfDoesNotExist('sxe-plan-docs-by-county', PlanDocsByCountyComponent);
                this.createElementIfDoesNotExist('sxe-products-doc-pdf-view', ProductsDocPdfViewComponent);
            }
        });
    }

    createElementIfDoesNotExist(elementName: string, elementComponent: any) {
        if (!customElements.get(elementName)) {
            const customElement = createCustomElement(elementComponent, { injector: this.injector });
            customElements.define(elementName, customElement);
        }
    }

    ngDoBootstrap() { }
}